import i18next from 'i18next'

i18next.addResources('es', 'datePicker', {
  from: 'Desde',
  to: 'Hasta'
})
